import FormattedMessage from 'I18n/components/FormattedMessage';
import { Link } from 'foundations-components/transitional/components/Link';
import { FREE } from 'self-service-api/constants/ProductLevels';
import { useHighlightedProductsHeaderConfig } from '../../../constants/merchCards/HighlightedProductsHeaderConfig';
import { jsx as _jsx } from "react/jsx-runtime";
export const StandardLowerTierMessage = ({
  productLine,
  productLevel,
  handleClick
}) => {
  // TODO - these translations are all coming from SSAPI, migrate to new format
  const configKeys = useHighlightedProductsHeaderConfig(productLine, productLevel);
  if (productLevel === FREE) {
    return /*#__PURE__*/_jsx(Link, {
      onClick: handleClick,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "merchCards.priorityFeatures.includes"
      })
    });
  }
  if (!(configKeys !== null && configKeys !== void 0 && configKeys.lowerTierPlus)) return null;
  return /*#__PURE__*/_jsx(FormattedMessage, {
    message: configKeys.lowerTierPlus
  });
};